var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14917 0 0 5.15103 0 11.5C0 17.8527 5.14917 23 11.5 23C17.8508 23 23 17.8527 23 11.5C23 5.15103 17.8508 0 11.5 0ZM11.5 5.10081C12.5756 5.10081 13.4476 5.97277 13.4476 7.04839C13.4476 8.12401 12.5756 8.99597 11.5 8.99597C10.4244 8.99597 9.55242 8.12401 9.55242 7.04839C9.55242 5.97277 10.4244 5.10081 11.5 5.10081ZM14.0968 16.879C14.0968 17.1863 13.8476 17.4355 13.5403 17.4355H9.45968C9.15238 17.4355 8.90323 17.1863 8.90323 16.879V15.7661C8.90323 15.4588 9.15238 15.2097 9.45968 15.2097H10.0161V12.2419H9.45968C9.15238 12.2419 8.90323 11.9928 8.90323 11.6855V10.5726C8.90323 10.2653 9.15238 10.0161 9.45968 10.0161H12.4274C12.7347 10.0161 12.9839 10.2653 12.9839 10.5726V15.2097H13.5403C13.8476 15.2097 14.0968 15.4588 14.0968 15.7661V16.879Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.07875367cf8ab2fe8ef83fa6b355e3ec.svg";
export { ForwardRef as ReactComponent };